import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import "../App.css";

const SignInModal = ({ isOpen, onSignIn }) => {
	if (!isOpen) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        const email = event.target.email.value;
        const password = event.target.password.value;
        onSignIn(email, password);
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <input type="email" name="email" required placeholder="Email" />
                <input type="password" name="password" required placeholder="Password" />
                <button type="submit">Sign In</button>
            </form>
        </div>
    );
};


SignInModal.propTypes = {
	isOpen: PropTypes.bool.isRequired, // Validate isOpen as a required boolean
	onSignIn: PropTypes.func.isRequired, // Validate onSignIn as a required function
};

export default SignInModal;
